"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flex = exports.Direction = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var React = __importStar(require("react"));
var styled_system_1 = require("styled-system");
var View_1 = require("../View");
var helpers_1 = require("./helpers");
exports.Direction = {
    HORIZONTAL: 'horizontal',
    VERTICAL: 'vertical',
};
var FlexGap = (0, styled_1.default)(View_1.View)((0, styled_system_1.system)({
    gap: { property: 'gap', scale: 'space' },
    rowGap: { property: 'rowGap', scale: 'space' },
    columnGap: { property: 'columnGap', scale: 'space' },
}));
exports.Flex = React.forwardRef(function (_a, ref) {
    var direction = _a.direction, _b = _a.reverse, reverse = _b === void 0 ? false : _b, wrap = _a.wrap, grow = _a.grow, shrink = _a.shrink, basis = _a.basis, align = _a.align, justify = _a.justify, props = __rest(_a, ["direction", "reverse", "wrap", "grow", "shrink", "basis", "align", "justify"]);
    var defaultDirection = direction || 'horizontal';
    var defaultWrap = wrap || false;
    var flexPropsWithShorthands = {
        alignItems: align,
        justifyContent: justify,
        flexDirection: (0, helpers_1.flexDirection)(defaultDirection, reverse),
        flexWrap: (0, helpers_1.flexWrap)(defaultWrap),
        flexGrow: grow,
        flexShrink: shrink,
        flexBasis: basis,
    };
    return (React.createElement(FlexGap, __assign({ ref: ref, display: "flex" }, flexPropsWithShorthands, props)));
});
//# sourceMappingURL=index.js.map